import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

const AlerteInfoBeta = ({ PeutLaisserAvis }) =>
    (!PeutLaisserAvis ? null : (
        <div className="alert alert-success" role="alert">
            <h4 className="alert-heading">Bienvenue sur la nouvelle interface de votre extranet de copropriété !</h4>
            <p className="m-0">
                Ceci est une avant-première de votre nouvel extranet Gérer-ma-Copro.<br />Vous pouvez tester cette
                nouvelle interface, ou bien{' '}
                <b>
                    <i>Retourner sur l&apos;ancienne interface</i>
                </b>{' '}
                à l’aide du bouton ci-dessus.
            </p>
            <hr />
            <p className="m-0 mb-1">
                Afin de satisfaire au mieux vos attentes, nous vous prions de bien vouloir prendre quelques minutes de
                votre temps pour nous faire part de votre avis.<span className="mr-3" />
                <Link to="/Reaction">
                    <button className="btn btn-success">Oui, je veux bien donner mon avis !</button>
                </Link>
            </p>
        </div>
    ));

function mapStateToProps({
    AdhStore: {
        Adh: { PeutLaisserAvis },
    },
}) {
    return { PeutLaisserAvis };
}

export default connect(mapStateToProps)(AlerteInfoBeta);



// WEBPACK FOOTER //
// ./src/components/Accueil/AlerteInfoBeta.js